'use strict';
import jquery from 'jquery/src/jquery.js';

// Local Storage Load 
import { loadDoorSettingsState, saveDoorSettingsState } from './service/localStorage-service';
// const persistedState = loadDoorSettingsState(); // Maybe removed this line after testing. Believe that it is only necessary in redux-service file
// Redux Store
import { doorSettingsStateStore } from './service/redux-service';

// Prevents window from moving on touch on older browsers.
//window.addEventListener('touchmove', function (event) { event.preventDefault() }, false)

// Prevents window from moving on touch on newer browsers.
window.addEventListener('touchmove', function (event) {
	event.preventDefault() 
}, {passive: false})

// Allows content to move on touch.
document.querySelector('body').addEventListener('touchmove', function (event) {
	event.stopPropagation()
}, false)


// Example
// const example = require('../../components/example/example');

// Inputs
//const sidepanelSettings = require('../../components/sidebar-menu/sidepanel-settings/sidepanel-settings');
const rangeSlider = require('../../components/inputs/range-slider/range-slider');
const checkbox = require('../../components/inputs/checkbox/checkbox');
const onOffSwitchCheckbox = require('../../components/inputs/on-off-switch/on-off-switch');

// Calculator
const calculatorService = require('./service/calculation-service');

// Pages
const startPage = require('../../components/start-page/start-page');

//Preset page is no longer in use
//const presetPage = require('../../components/preset-page/preset-page');
const resultPage = require('../../components/result-page/result-page');

// Sidebar
const sidebarMenu = require('../../components/sidebar-menu/sidebar-menu');
const sidepanelCustomize = require('../../components/sidebar-menu/sidepanel-customize/sidepanel-customize');

// Popup Modal
const example = require('../../components/modal/modal');

//Mobile menu
const mobileMenu = require('../../components/mobile-menu/mobile-menu');

//Cookie
const cookie = require('../../components/cookie-bar/cookie-bar')

// Local Storage Save
doorSettingsStateStore.subscribe(() => {
	saveDoorSettingsState( doorSettingsStateStore.getState());
});

//Version handling - Manual
const currentVersion = "v1.0.1";
$('.js-current-version').text(currentVersion);

// Services
const svgService = require('./service/svg-service');
const unitConvertService = require('./service/unit-convert-service');
const languageService = require('./service/language-service');

var btnSave = document.getElementById('btnSave');
var deferredPrompt;

//service worker for caching in offline/app mode
if ('serviceWorker' in navigator) {  
	navigator.serviceWorker.register('./service-worker.js').then(function (registration) { 
	console.log("ServiceWorker registration succeeded."); 
	}).catch(function (err) { 
	 console.log('ServiceWorker registration failed: ', err);  
	});
}

window.addEventListener('beforeinstallprompt', function(e) {
	console.log('beforeinstallprompt Event fired');
	e.preventDefault();
  
	// Stash the event so it can be triggered later.
	deferredPrompt = e;
  
	return false;
  });
  
  btnSave.addEventListener('click', function() {
	if(deferredPrompt !== undefined) {
	  // The user has had a postive interaction with our app and Chrome
	  // has tried to prompt previously, so let's show the prompt.
	  deferredPrompt.prompt();
  
	  // Follow what the user has done with the prompt.
	  deferredPrompt.userChoice.then(function(choiceResult) {
  
		console.log(choiceResult.outcome);
  
		if(choiceResult.outcome == 'dismissed') {
		  console.log('User cancelled home screen install');
		}
		else {
		  console.log('User added to home screen');
		}
  
		// We no longer need the prompt.  Clear it up.
		deferredPrompt = null;
	  });
	}
  });

/*btnAdd.addEventListener('click', (e) => {
	// hide our user interface that shows our A2HS button
	btnAdd.style.display = 'none';
	// Show the prompt
	deferredPrompt.prompt();
	// Wait for the user to respond to the prompt
	deferredPrompt.userChoice
	  .then((choiceResult) => {
		if (choiceResult.outcome === 'accepted') {
		  console.log('User accepted the A2HS prompt');
		} else {
		  console.log('User dismissed the A2HS prompt');
		}
		deferredPrompt = null;
	  });
  });*/
   



// WEBPACK FOOTER //
// ./src/assets/scripts/index.js